import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { Sort } from '@angular/material/sort';
import * as _ from 'lodash';
import { Router } from '@angular/router';
import { ICompany, ICompanyFilter } from './companies.interface';
import { CompaniesService } from './companies.service';
import { CompaniesModalComponent } from './companies-modal/companies-modal.component';
import { SubscriptionsService } from '../../subscriptions-page/subscriptions/subscriptions.service';
import { Broadcaster } from '../../../shared/components/broadcaster.component';
import { DialogService } from '../../../shared/services/dialog/dialog.service';
import { AuthService } from '../../../shared/services/auth.service';
import { IConfirmationDialogOptions } from '../../../shared/services/dialog/confirmation-dialog/confirmation-dialog-options.interface';
import { SubscriptionsModalComponent } from '../../subscriptions-page/subscriptions/subscriptions-modal/subscriptions-modal.component';

let self: any;

@Component({
  selector: 'app-companies',
  templateUrl: './companies.component.html',
  styleUrls: ['./companies.component.css']
})
export class CompaniesComponent implements OnInit {
  companies: ICompany[] = [];
  loading: boolean = false;
  thereAreMore: boolean = false;
  filter: ICompanyFilter = {
    filters: {},
    skip: 0,
    limit: 20
  };
  filtered = false;
  scrollSubscription!: Subscription;
  sortOptions: any = {
    "name": 'Nombre asc',
    "-name": 'Nombre desc',
  };
  sortOptionsKeys = Object.keys(this.sortOptions);
  selection: any = { all: false };
  isDev: any;

  constructor(
    private _CompaniesService: CompaniesService,
    private _SubscriptionsService: SubscriptionsService,
    private _broadcaster: Broadcaster,
    private _dialogService: DialogService,
    private _dialog: MatDialog,
    private _viewContainerRef: ViewContainerRef,
    private router: Router,
    private _AuthService: AuthService
  ) {
    self = this;
    this.registerStringBroadcast();
  }

  ngOnInit() {
    this.isDev = this._AuthService.isRole('dev');
    this.getCompanies(true);
  }

  getCompanies(reset?: boolean) {
    this.loading = true;
    this.thereAreMore = false;
    if (reset) {
      window.scroll(0, 0);
      this.filter.skip = 0;
      this.companies = [];
      this.clearSelection();
    }
    this._CompaniesService.getCompanies(this.filter).subscribe((companies: any) => {
      this.companies = _.concat(this.companies, companies);
      const filter: any = this.filter;
      this.thereAreMore = companies.length >= filter.limit;
      this.loading = false;
    })
  }

  loadMore() {
    if (this.thereAreMore && !this.loading) {
      const filter: any = this.filter;
      filter.skip += filter.limit;
      this.getCompanies();
    }
  }

  registerStringBroadcast() {
    this.scrollSubscription = this._broadcaster.on<string>('FinishScrollDown')
      .subscribe(() => {
        this.loadMore();
      });
  }

  ngOnDestroy() {
    this.scrollSubscription.unsubscribe();
  }

  sortCompanies(sort: any) {
    // this.filter.sort = (typeof sort == 'string') ? sort : ((sort.direction == 'asc') ? '' : '-') + sort.active;
    this.getCompanies(true);
  }

  openFilter() {
    console.log('openFilter');
  }

  openCompaniesStats() {
    this.router.navigate(['/admin', this._AuthService.companyIndex(), 'companies-stats']);
  }

  openNewCompanyModal() {
    this.openCompanyModal({});
  }

  openCompanyModal(company: ICompany, readOnly: boolean = false) {
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '600px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(CompaniesModalComponent, config);
    self.dialogRef.componentInstance.company = company;
    self.dialogRef.componentInstance.readOnly = readOnly;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      if (result) this.getCompanies(true);
    });
  }

  openDeleteCompanyConfirm(company: ICompany, hardDelete: boolean = false) {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Eliminar Empresa",
      message: "Esta seguro que desea eliminar '" + company.name + "'?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this._CompaniesService.deleteCompany(company, hardDelete).subscribe(() => {
            if (hardDelete) this.getCompanies(true);
            else company.isDeleted = true;
          })
        }
      });
  }

  openRestoreCompanyConfirm(company: ICompany) {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Restaurar Empresa",
      message: "Esta seguro que desea restaurar '" + company.name + "'?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this._CompaniesService.restoreCompany(company).subscribe(() => {
            company.isDeleted = false;
          })
        }
      });
  }

  openSubscriptionModal(company: ICompany, readOnly: boolean = false) {
    this._SubscriptionsService.getSubscriptions({ filters: { company: company._id } }).subscribe(subscriptions => {
      const subscription = _.first(subscriptions) || { company: company, features: [] }
      let config = new MatDialogConfig();
      config.width = '400px';
      config.maxWidth = '90vw';
      config.viewContainerRef = this._viewContainerRef;
      self.dialogRef = this._dialog.open(SubscriptionsModalComponent, config);
      self.dialogRef.componentInstance.subscription = subscription;
      self.dialogRef.componentInstance.readOnly = readOnly;

      self.dialogRef.afterClosed().subscribe((result: any) => {
        self.dialogRef = null;
      });
    })
  }

  clearSelection() {
    this.selection = { all: false }
  }

  checkSomeSelected() {
    this.selection.some = Object.keys(this.selection)
      .filter(el => el !== 'all' && el !== 'some')
      .filter(el => this.selection[el])
      .length > 0;
  }
  
  toggleSelection(_id?: string) {
    if (_id) {
      // Modificar la selección de un elemento individual
      this.selection[_id] = !this.selection[_id];

      // Verificar si todos los elementos están seleccionados
      const allSelected = this.companies.every(company => {
        const id = company?._id || '';
        return this.selection[id];
      });

      // Actualizar "seleccionar todos" en base a los elementos seleccionados
      this.selection.all = allSelected;
    } else {
      // Seleccionar o deseleccionar todos
      const newValue = !this.selection.all;
      this.selection = { all: newValue };

      // Aplicar el nuevo estado a todos los elementos
      this.companies.forEach(company => {
        const id = company?._id || '';
        this.selection[id] = newValue;
      });
    }

    // Actualizar si hay alguna selección
    this.checkSomeSelected();
  }
}